import React from 'react';
import { Autocomplete, TextField, Checkbox, AutocompleteProps } from '@mui/material';

interface Option {
  label: string;
  value: string;
}

interface AutocompleteMultipleProps
  extends Omit<
    AutocompleteProps<Option, true, false, false>,
    'multiple' | 'renderTags' | 'renderOption' | 'renderInput'
  > {
  options: Option[];
  value: Option[];
  onChange: (event: any, newValue: Option[]) => void;
  label?: string;
  placeholder?: string;
  size?: 'small' | 'medium';
}

export const AutocompleteMultiple: React.FC<AutocompleteMultipleProps> = ({
  options,
  value,
  onChange,
  label,
  placeholder,
  size = 'small',
  ...props
}) => {
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={options}
      getOptionLabel={(option) => option.label}
      value={value}
      onChange={onChange}
      {...props}
      renderTags={(value) => value.map((option) => option.label).join(', ')}
      renderOption={(props, option, { selected }) => (
        <li {...props} key={props.key} style={{ padding: '4px 16px', fontWeight: selected ? 700 : 400 }}>
          <Checkbox disableRipple disableFocusRipple disableTouchRipple checked={selected} sx={{ p: 1, mr: 1 }} />
          {option.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{
            '& .MuiOutlinedInput-root': {
              background: '#FFFFFF',
            },
            '& .MuiAutocomplete-inputRoot': {
              height: 'auto',
              minHeight: '44px',
            },
          }}
          label={label}
          placeholder={value.length > 0 ? '' : placeholder}
          size={size}
        />
      )}
    />
  );
};
